import { useTranslation } from 'react-i18next'

import CircleCheck from '@/assets/icons/circle-check.svg'

export const ReminderBanner = () => {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-4 bg-gray-background p-5 shadow-soft" data-testid="reminder-banner">
      <img src={CircleCheck} className="h-7" />
      <label> {t('reminder_set')}</label>
    </div>
  )
}
